import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ShowMoreDirective } from '@app/shared/directives/show-more.directive';
import { ClickableLinksPipe } from '@app/shared/pipes/clickable-links.pipe';
import { RecurrencePipe } from '@app/shared/pipes/recurrence.pipe';
import { PublicMeeting } from 'lfx-pcc';
import { DateTime } from 'luxon';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'lfx-meeting-details',
  standalone: true,
  imports: [DatePipe, CommonModule, ShowMoreDirective, ButtonModule, RecurrencePipe, TooltipModule, CdkCopyToClipboard, ClickableLinksPipe],
  templateUrl: './meeting-details.component.html',
  styleUrl: './meeting-details.component.scss',
})
export class MeetingDetailsComponent {
  public meeting: PublicMeeting;
  public occurrenceLink: string = '';
  public copyTooltip: string = 'Copy meeting occurrence link';
  public hideDelay: number | undefined = undefined;

  private dialogConfig: DynamicDialogConfig<PublicMeeting> = inject(DynamicDialogConfig);

  public constructor() {
    this.meeting = this.dialogConfig?.data as PublicMeeting;

    const location = new URL(window.location.href);
    // Append the meeting ID to the current URL as a query parameter
    location.searchParams.set('occurrence', this.meeting.id.toString());
    this.occurrenceLink = location.toString();
  }

  public get isPast(): boolean {
    if (this.meeting.end) {
      return DateTime.fromISO(this.meeting.end).plus({ minutes: 40 }) < DateTime.now();
    }

    return false;
  }

  public get showAISummaryURL(): boolean {
    return (
      this.isPast &&
      !!this.meeting.extendedProps.zoom_ai_enabled &&
      !!this.meeting.extendedProps.ai_summary_url &&
      (!!this.meeting.extendedProps.ai_summary_approved || !this.meeting.extendedProps.require_ai_summary_approval)
    );
  }

  public onCopy(): void {
    this.hideDelay = 3000;
    this.copyTooltip = 'Copied!';
    setTimeout(() => {
      this.copyTooltip = 'Copy meeting occurrence link';
      this.hideDelay = undefined;
    }, 2000);
  }
}
